import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

import { computed, inject } from 'vue';
import { Translator } from 'js/shims-vue';

type HeadingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

interface PrefixColoredIcon {
    icon?: string;
    color?: string;
}

interface Props {
    labelTitle: string;
    showTooltip?: boolean;
    labelTooltip?: string;
    variant?: HeadingVariant;
    prefixColoredIcon?: PrefixColoredIcon;
    showBackButton?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Heading',
  props: {
    labelTitle: {},
    showTooltip: { type: Boolean, default: true },
    labelTooltip: { default: '' },
    variant: { default: 'h1' },
    prefixColoredIcon: { default: () => ({}) },
    showBackButton: { type: Boolean, default: false }
  },
  emits: ["go-back"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $t = inject('$t') as Translator;

const tooltipContent = computed<string>(() => {
    return props.labelTooltip || $t.__('common.actions.back');
});

const containerClass = computed<string[]>(() => {
    return ['heading', `heading--${props.variant.toLowerCase()}`];
});

const fontClass = computed<string[]>(() => {
    return ['heading__title', `typographies-heading-${props.variant.toLowerCase()}`];
});

const iconSize = computed<string>(() => {
    return props.variant === 'h2'
        ? CompassEnums.ColoredIconSize.LARGE
        : CompassEnums.ColoredIconSize.MEDIUM;
});

const hasPrefixColoredIcon = computed<boolean>(() => {
    return Object.keys(props.prefixColoredIcon).length > 0;
});

const handleClick = (): void => {
    emit('go-back');
};

return (_ctx: any,_cache: any) => {
  const _component_CompassIconButton = _resolveComponent("CompassIconButton")!
  const _component_CompassTooltip = _resolveComponent("CompassTooltip")!
  const _component_CompassColoredIcon = _resolveComponent("CompassColoredIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(containerClass.value)
  }, [
    (__props.showBackButton)
      ? (_openBlock(), _createBlock(_component_CompassTooltip, {
          key: 0,
          content: tooltipContent.value,
          placement: _ctx.CompassEnums.TooltipPosition.BOTTOM_START,
          arrow: false,
          disabled: !__props.showTooltip
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CompassIconButton, {
              icon: "caret-left",
              onClick: handleClick
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content", "placement", "disabled"]))
      : _createCommentVNode("v-if", true),
    (hasPrefixColoredIcon.value)
      ? (_openBlock(), _createBlock(_component_CompassColoredIcon, {
          key: 1,
          class: "heading__icon",
          icon: __props.prefixColoredIcon.icon,
          color: __props.prefixColoredIcon.color,
          size: iconSize.value
        }, null, 8 /* PROPS */, ["icon", "color", "size"]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.variant), {
      class: _normalizeClass(fontClass.value)
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.labelTitle), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class"])),
    _renderSlot(_ctx.$slots, "default")
  ], 2 /* CLASS */))
}
}

})